import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../Estilos/Estilo.scss'
import Offcanvas from 'react-bootstrap/Offcanvas';

class Header extends React.Component {
  render() {
    const windowWidth = window.innerWidth;
    const isDesktop = windowWidth > 600;
    return (
      <div className="header">
        <header className="App-header">
          <div className="banner">
            <div className="logo">
              <img src="assets/img/logos/GRyS-logo-alpha-75.png" alt="GRyS logo" className="banner-logo" height="50" />
            </div>
            <div className="banner-text">
              <h1 className="english-name">Group of Next-Generation Networks and Services</h1>
              {isDesktop ? <h2 className="motto">Driving innovation in the networks and services of the future</h2> : null}
            </div>
          </div>


          <Navbar key="sm" bg="light" expand="sm" className="mb-3">
            <Container fluid>
			{/*<Navbar.Brand href="#">GRyS</Navbar.Brand>*/}
              <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-sm`} />
              <Navbar.Offcanvas
                id={`offcanvasNavbar-expand-sm`}
                aria-labelledby={`offcanvasNavbarLabel-expand-sm`}
                placement="end"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id={`offcanvasNavbarLabel-expand-sm`}>
                    GRyS
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="flex-grow-1 pe-3">
                  <Nav.Link href="/">Home</Nav.Link>
                  <NavDropdown title="GRyS" id="navbarScrollingDropdown">
                    <NavDropdown.Item href="/about">About GRyS</NavDropdown.Item>
                    <NavDropdown.Item href="/team">Team</NavDropdown.Item>
                    <NavDropdown.Item href="/sdg" >Sustainable Development Goals</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="/phd-theses">PhD Theses</NavDropdown.Item>
                    <NavDropdown.Item href="/master-theses">Master Theses</NavDropdown.Item>
                    <NavDropdown.Item href="/bsc-projects">Bachelor Degree Final Projects</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="https://portalcientifico.upm.es/es/ipublic/entity/16280" target="_blank" title="GRyS profile at the UPM Scientific Portal">UPM Scientific Portal</NavDropdown.Item>
                    <NavDropdown.Item href="https://www.upm.es/recursosidi/map/grupo-de-redes-y-servicios-de-proxima-generacion-grys/" target="_blank" title="GRyS profile at the UPM Innovation Hub">UPM Innovation Hub</NavDropdown.Item>
                    <NavDropdown.Item href="https://www.upm.es/observatorio/vi/index.jsp?pageac=estructuras/grupo.jsp&idGrupo=400&h=1" target="_blank" title="GRyS profile at the UPM R+D+i Observatory">UPM R+D+i Observatory</NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown title="Research" id="navbarScrollingDropdown">
                    <NavDropdown.Item href="/research-areas">Research Areas</NavDropdown.Item>
                    <NavDropdown.Item href="/publications">Publications</NavDropdown.Item>
                    <NavDropdown.Item href="/projects">Projects</NavDropdown.Item>
                    {/*<NavDropdown.Item href="http://gryslab.etsist.upm.es" target="_blank">Living Lab</NavDropdown.Item>*/}
                  </NavDropdown>
                  <NavDropdown title="Innovation" id="navbarScrollingDropdown">
                    <NavDropdown.Item href="/technology-transfer">Technology Transfer</NavDropdown.Item>
                    {/*<NavDropdown.Item href="#action4" disabled>Servicios científico-tecnológicos</NavDropdown.Item>*/}
                    <NavDropdown.Item href="https://www.upm.es/recursosidi/search/?_sft_product_cat=soluciones-tecnologicas&_sft_donde=grupo-de-redes-y-servicios-de-proxima-generacion-grys&sort_order=date+desc" target="_blank">Technological Solutions</NavDropdown.Item>
                    <NavDropdown.Item href="https://github.com/grys-upm" target="_blank">GitHub</NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown title="Communication" id="navbarScrollingDropdown">
                    <NavDropdown.Item href="/news">News</NavDropdown.Item>
                    <NavDropdown.Item href="/events">Events</NavDropdown.Item>
                    <NavDropdown.Item href="/offers">Offers</NavDropdown.Item>
                    <NavDropdown.Item href="/press-notes">Press Releases</NavDropdown.Item>
                    {/* <NavDropdown.Item href="#action4" disabled>Identidad gráfica</NavDropdown.Item>	*/}
                  </NavDropdown>

                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        </header>
      </div>
    )
  }
}

export default Header;